import { render, staticRenderFns } from "./pageView.vue?vue&type=template&id=76d90c4c&scoped=true&"
import script from "./pageView.vue?vue&type=script&lang=js&"
export * from "./pageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d90c4c",
  null
  
)

export default component.exports